import { Input } from "shared/ui/Input";
import { Button } from "shared/ui/button";
import { DisabledElementModal } from "widgets/disabled-element-modal";
import { useModal } from "shared/ui/modal";
import styles from "./FormSection.module.scss";

export const FormSection = ({ formTitle, formImg }) => {
  const {
    isModalOpen: isDisabledElementModalOpen,
    open: openDisabledElementModal,
    close: closeDisabledElementModal,
    toggle: toggleDisabledElementModal,
  } = useModal(false);

  return (
    <>
      <div className={styles.formContainer}>
        <div className={styles.formWrapper}>
          <p className={styles.formWrapper__title}>{formTitle}</p>
          <div className={styles.formWrapper__form}>
            <div>
              <p className={styles.formWrapper__label}>Ваше имя</p>
              <Input
                type="text"
                placeholder="Введите имя"
                onClick={openDisabledElementModal}
                readonly={true}
                className={styles.formWrapper__input}
              />
            </div>
            <div>
              <p className={styles.formWrapper__label}>Номер телефона</p>
              <Input
                type="text"
                placeholder="Введите номер телефона"
                onClick={openDisabledElementModal}
                readonly={true}
                className={styles.formWrapper__input}
              />
            </div>
            <div>
              <p className={styles.formWrapper__label}>Комментарий</p>
              <Input
                type="text"
                placeholder=""
                onClick={openDisabledElementModal}
                readonly={true}
                className={`${styles.formWrapper__input} ${styles.formWrapper__inputWide}`}
              />
            </div>
          </div>
          <Button
            variant="disabled"
            size="large"
            onClick={openDisabledElementModal}
          >
            Отправить
          </Button>
        </div>
        <div className={styles.imgWrapper}>
          <img src={formImg} className={styles.imgWrapper__img} alt="formImg" />
        </div>
      </div>
      <DisabledElementModal
        isModalOpen={isDisabledElementModalOpen}
        open={openDisabledElementModal}
        close={closeDisabledElementModal}
        toggle={toggleDisabledElementModal}
      />
    </>
  );
};
